import { render } from "./LecheFria.vue?vue&type=template&id=73abfbd2"
import script from "./LecheFria.vue?vue&type=script&lang=js"
export * from "./LecheFria.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__